(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["paragraph-highlighter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const anchorSelector = '.paragraph-highlighter__buttons a[href^="#"]';
    const offsetStyle = document.createElement('style');
    document.head.appendChild(offsetStyle);

    function updateAnchorOffsets() {
      const header = document.querySelector('.page-header');
      const headerHeight = header ? header.getBoundingClientRect().height : 0;
      const targets = new Set();

      document.querySelectorAll(anchorSelector).forEach((link) => {
        const targetId = link.getAttribute('href').slice(1);
        if (targetId && document.getElementById(targetId)) {
          targets.add(`#${CSS.escape(targetId)}`);
        }
      });

      offsetStyle.textContent = targets.size
        ? `${[...targets].join(', ')} { scroll-margin-top: ${headerHeight + 16}px; }`
        : '';
    }

    function scheduleAnchorOffsets() {
      requestAnimationFrame(updateAnchorOffsets);
    }

    updateAnchorOffsets();

    const header = document.querySelector('.page-header');
    if (header) {
      new ResizeObserver(updateAnchorOffsets).observe(header);
    }

    window.addEventListener('resize', scheduleAnchorOffsets);
    document.addEventListener('shopify:section:load', scheduleAnchorOffsets);
    document.addEventListener('shopify:section:unload', scheduleAnchorOffsets);
    document.addEventListener('click', (event) => {
      if (event.target.closest(anchorSelector)) updateAnchorOffsets();
    });

    if (!window.IntersectionObserver || !Element.prototype.animate) return;

    const appearSelector = '.paragraph-highlighter[data-appear]';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const appearObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        appearObserver.unobserve(entry.target);
        if (reducedMotion.matches) return;

        entry.target.animate(
          [
            { opacity: 0, transform: 'translateY(20%)' },
            { opacity: 1, transform: 'translateY(0)' }
          ],
          { duration: 800, easing: 'ease-out' }
        );
      });
    });

    function initAppear(root) {
      root.querySelectorAll(appearSelector).forEach((element) => appearObserver.observe(element));
    }

    initAppear(document);
    document.addEventListener('shopify:section:load', (event) => initAppear(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(appearSelector).forEach((element) => appearObserver.unobserve(element));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-product-swiper"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  function everyday() {
    var ScreenWidth = document.documentElement.clientWidth || window.innerWidth;
    var isPC = ScreenWidth > 1183;

    var maxHeight = 0;
    var swiperItems = document.querySelectorAll(".ro-pet-product-swiper .my-swiper-item");
    swiperItems.forEach(function(item) {
      var height = item.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });
    swiperItems.forEach(function(item) {
      item.style.height = maxHeight + 'px';
    });

    new Swiper("#everyday-features-swiper", {
      direction: "horizontal",
      centeredSlides: false,
      slidesPerView: "auto",
      spaceBetween: 16,
      grabCursor: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    function hideButton() {
      var buttons = document.querySelectorAll(".ro-pet-product-swiper .button-line > div");
      buttons.forEach(function(button) {
        button.style.display = "none";
      });
    }

    function showButton() {
      var buttons = document.querySelectorAll(".ro-pet-product-swiper .button-line > div");
      buttons.forEach(function(button) {
        button.style.display = "block";
      });
    }

    if (isPC) {
      hideButton();
      var swiperBlock = document.querySelector(".ro-pet-product-swiper .my-swiper-block");
      swiperBlock.addEventListener('mouseenter', showButton);
      swiperBlock.addEventListener('mouseleave', hideButton);
    }
  }

  everyday();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read base URL from data attribute
  var baseUrl = productRecommendationsSection.dataset.baseUrl;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = baseUrl + "?section_id=product-recommendations&limit=" + limit;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
    }
  };
  request.send();
};

// Listen for changes done in the Theme Editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["world-cup-how-it-works"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const section = document.getElementById('shopify-section-{{ section.id }}');
    if (section) {
      section.classList.add('loaded');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
